const DEFAULT_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:4002');

export const API_BASE_URL = DEFAULT_API_BASE_URL;

export function buildApiUrl(path) {
  return `${API_BASE_URL}${path}`;
}
